
function init () {
  $(":radio[name='banben']").click(function () {
    var index = $(":radio[name='banben']").index($(this))
    if (index === 0) {
      $('.banben').addClass('foucs')
      $('.banben2').removeClass('foucs')
    } else {
      $('.banben2').addClass('foucs')
      $('.banben').removeClass('foucs')
    }
  })
}

export {
  init
}



// WEBPACK FOOTER //
// ./src/components/common/common/loginNreg/effects.js